<template>
  <div class="bg bg11">
    <div class="class--con">
      <class-but @forward="forward"/>
    </div>
  </div>
</template>

<script>
import ClassBut from "@/views/conference/ConferenceItem/classBut.vue";


export default {
  name: "howAreWeLearning",
  components: {ClassBut},
  data() {
    return {}
  },
  methods: {
    forward() {
      this.$router.push({
        name: 'reportClassV1',
        query: this.$route.query,
      })
    },
  }
}
</script>

<style lang="less" scoped>
@import "reportClass.less";
</style>
